
import React, { useState } from 'react';
import { Cog, ChevronUp, ChevronDown } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface SystemSettingsTabProps {
  onSaveSettings: (section: string) => void;
}

const SystemSettingsTab: React.FC<SystemSettingsTabProps> = ({ onSaveSettings }) => {
  const [isMenuCondensed, setIsMenuCondensed] = useState(false);

  const toggleMenuCondensed = () => {
    setIsMenuCondensed(!isMenuCondensed);
  };

  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-center">
          <div>
            <CardTitle>System Configuration</CardTitle>
            <CardDescription>
              Configure global system settings for the SaaS platform
            </CardDescription>
          </div>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={toggleMenuCondensed}
            className="flex items-center gap-1"
          >
            {isMenuCondensed ? (
              <>
                <span>Expand Menu</span>
                <ChevronDown className="h-4 w-4" />
              </>
            ) : (
              <>
                <span>Condense Menu</span>
                <ChevronUp className="h-4 w-4" />
              </>
            )}
          </Button>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {!isMenuCondensed && (
          <>
            <div className="space-y-2">
              <Label htmlFor="platformName">Platform Name</Label>
              <Input 
                id="platformName" 
                defaultValue="ReferMe.site" 
                placeholder="Platform Name" 
              />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="supportEmail">Support Email</Label>
              <Input 
                id="supportEmail" 
                defaultValue="support@referme.site" 
                placeholder="Support Email" 
              />
            </div>
            
            {/* The maximum instances per business setting has been removed */}
          </>
        )}
        
        <div className="pt-4">
          <Button onClick={() => onSaveSettings('System')}>
            Save System Settings
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default SystemSettingsTab;
